import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import LayersIcon from '@mui/icons-material/Layers';
const StyledBadge = styled(Badge)(({
  theme
}) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#2932E5',
    color: 'white',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '11px',
    fontWeight: 600,
    height: '18px',
    minWidth: '18px',
    padding: '0 5px',
    borderRadius: '9px'
  }
}));
const HistoricalBadge = styled(Badge)(({
  theme
}) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#FF8555',
    color: 'white',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '11px',
    fontWeight: 600,
    height: '18px',
    minWidth: '18px',
    padding: '0 5px',
    borderRadius: '9px'
  }
}));
export function SessionNumberDisplay({
  sessionNumber,
  isHistorical = true,
  onClick,
  dirCurrentSession,
  pinCount = 0

}) {
  
  // const isCurrentSession = !sessionNumber?.id?true:sessionNumber?.id === dirCurrentSession?.id?true:false;
  const isCurrentSession=true;
  const sessionDisplayNumber = sessionNumber?.name?.split('_')[1] || '1';
  
  const tooltipContent = (
    <Box>
      <Typography
        sx={{
          color: 'white',
          fontWeight: 600,
          fontSize: '10px',
          mb: 1,
          fontFamily: 'Roboto, sans-serif',
        }}
      >
        Selected Sessions (1)
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        <Box
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#2932E5',
            mr: 1.5
          }}
        />
        <Typography
          sx={{
            color: 'white',
            fontSize: '10px',
            fontFamily: 'Roboto, sans-serif'
          }}
        >
          Session {sessionNumber} {isCurrentSession ? '(Current)' : ''} - {pinCount} pins
        </Typography>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.2)', my: 1.5 }} />

      <Typography
        sx={{
          color: 'white',
          fontWeight: 600,
          fontSize: '14px',
          mb: 1,
          fontFamily: 'Roboto, sans-serif'
        }}
      >
        Total: {pinCount} pins
      </Typography>

      <Typography
        sx={{
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '12px',
          fontFamily: 'Roboto, sans-serif',
          cursor: 'pointer',
          '&:hover': {
            color: 'white'
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick();
        }}
      >
        Click to manage sessions
      </Typography>
    </Box>
  );
  
  return <Badge 
    sx={{
      '& .MuiBadge-badge': isCurrentSession ? {
        backgroundColor: '#2932E5',
        color: 'white',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '11px',
        fontWeight: 600,
        height: '18px',
        minWidth: '18px',
        padding: '0 5px',
        borderRadius: '9px'
      } : {
        backgroundColor: '#FF8555',
        color: 'white',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '11px',
        fontWeight: 600,
        height: '18px',
        minWidth: '18px',
        padding: '0 5px',
        borderRadius: '9px'
      }
    }} 
    badgeContent={sessionNumber} 
    max={999}
  >
      <Tooltip
        title={tooltipContent}
        arrow
        placement="bottom"
        enterDelay={200}
        leaveDelay={100}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'black',
              opacity:0.7,
              borderRadius: '8px',
              padding: '5px',
              minWidth: '100px',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              '& .MuiTooltip-arrow': {
                color: '#4A5565',
              }
            }
          },
          popper: {
            sx: {
              zIndex: 1300
            }
          }
        }}
      >
        <Button 
          onClick={onClick} 
          variant="outlined" 
          size="small" 
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '13px',
            fontWeight: 500,
            color: isCurrentSession ? '#4A5565' : '#FF8555',
            borderColor: '#E5E7EB',
            bgcolor: 'white',
            textTransform: 'none',
            minWidth: '36px',
            px: 0,
            py: 0.75,
            borderRadius: '8px',
            cursor: onClick ? 'pointer' : 'default',
            '&:hover': {
              borderColor: isCurrentSession ? '#2932E5' : '#FF8555',
              bgcolor: isCurrentSession ? 'rgba(41, 50, 229, 0.04)' : 'rgba(255, 133, 85, 0.04)'
            }
          }}
        >
          <LayersIcon sx={{ fontSize: 20 }} />
        </Button>
      </Tooltip>
    </Badge>;
}